import { __decorate, __param } from '../../../../../../../external/tslib/tslib.es6.js';
import { DisposableStore } from '../../../../base/common/lifecycle.js';
import { IContextMenuService } from '../../../../platform/contextview/browser/contextView.service.js';
import { ILayoutService } from '../../../../platform/layout/browser/layoutService.service.js';
import { Registry } from '../../../../platform/registry/common/platform.js';
import { Extensions } from '../../../common/contributions.js';
let ContextMenuContribution = class ContextMenuContribution {
    constructor(layoutService, contextMenuService) {
        this.disposables = ( new DisposableStore());
        const update = (visible) => layoutService.activeContainer.classList.toggle('context-menu-visible', visible);
        contextMenuService.onDidShowContextMenu(() => update(true), null, this.disposables);
        contextMenuService.onDidHideContextMenu(() => update(false), null, this.disposables);
    }
};
ContextMenuContribution = ( __decorate([
    ( __param(0, ILayoutService)),
    ( __param(1, IContextMenuService))
], ContextMenuContribution));
( Registry.as(Extensions.Workbench))
    .registerWorkbenchContribution(ContextMenuContribution, 4 );
